import { cookiesToZGUID, cookiesToZUID } from '@zillow/mortgage-urls';
import { emitExperimentEvent } from '../analytics/events';

declare global {
  interface Window {
    optimizely?: {
      get?: (key: 'state') => {
        getExperimentStates: () => Array<{
          isActive: boolean;
          id: string;
          variation: {
            id: string;
            name: string;
          };
        }>;
      };
    } | null;
  }
}

/**
 * Tracks Optimizely exposure events for active experiments.
 *
 * This function checks for active Optimizely experiments and sends exposure
 * events to clickstream analytics when experiments are found.
 */
export function trackExposureEvent(): void {
  const experimentStates =
    window.optimizely && typeof window.optimizely.get === 'function' ? window.optimizely.get('state') : null;

  const experiments =
    experimentStates && typeof experimentStates.getExperimentStates === 'function'
      ? experimentStates.getExperimentStates()
      : null;

  if (experiments && typeof experiments === 'object') {
    // Build an array of active Optimizely treatments and their variation.
    const treatments: Array<string> = [];
    for (const key in experiments) {
      const experiment = experiments[key];
      // We only want to track active experiments.
      if (experiment.hasOwnProperty('isActive') && experiment.isActive) {
        if (experiment.hasOwnProperty('id') && experiment.hasOwnProperty('variation') && experiment.variation) {
          let treatmentName = `OPTIMIZELY_${experiment.id}`;
          // If a variation name contains the word "control" (any case), we will use CONTROL as the variation name.
          const variationName = experiment.variation.name;
          if (variationName.toLowerCase().includes('control')) {
            treatmentName = treatmentName + '.CONTROL';
          } else {
            treatmentName = treatmentName + '.V_' + experiment.variation.id;
          }
          treatments.push(treatmentName);
        }
      }
    }
    // Set randomizationKey to the ZUID if exists, or a GUID if not.
    let keyType = 'zuid';
    let randomizationKey = cookiesToZUID(document.cookie);
    if (typeof randomizationKey !== 'string' || randomizationKey.toLowerCase() === 'null') {
      keyType = 'guid';
      randomizationKey = cookiesToZGUID(document.cookie);
    }
    // Track exposure events if treatments exist and randomizationKey is set.
    if (typeof randomizationKey === 'string' && randomizationKey.toLowerCase() !== 'null' && treatments.length > 0) {
      emitExperimentEvent({ keyType, randomizationKey, treatments });
    }
  }
}
